// Recorded machine-spend receipt bundles for the Beacon Overview ledger.
//
// Four REAL sealed resource_purchased packages produced by
// scripts/generate-spend-receipts.ts (deterministic gig + in-process witness),
// inlined at build like apps/demo/src/data.ts does for the Torbridge invoices.
// All four share one agent identity and differ only in amount/category (and
// thus the conformance verdict):
//   purchase-search-api    $96    search_api    -> conformant: true
//   purchase-licensed-data $320   licensed_data -> conformant: true
//   purchase-compute       $390   compute       -> conformant: true
//   purchase-over-cap      $1,000 licensed_data -> conformant: false (over cap)
import purchaseSearchApi from "../../../demo-artifacts-spend/receipts/purchase-search-api/bundle.json";
import purchaseLicensedData from "../../../demo-artifacts-spend/receipts/purchase-licensed-data/bundle.json";
import purchaseCompute from "../../../demo-artifacts-spend/receipts/purchase-compute/bundle.json";
import purchaseOverCap from "../../../demo-artifacts-spend/receipts/purchase-over-cap/bundle.json";

export type Bundle = Record<string, string>;

// Keyed by the bundleId each ledger row references.
export const BEACON_BUNDLES: Record<string, Bundle> = {
  "purchase-search-api": purchaseSearchApi as Bundle,
  "purchase-licensed-data": purchaseLicensedData as Bundle,
  "purchase-compute": purchaseCompute as Bundle,
  "purchase-over-cap": purchaseOverCap as Bundle
};
